import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled from 'styled-components';
import { Label } from 'oxyrion-ui/lib';
import Loader from 'oxyrion-ui/lib/Loader';
import Img from 'react-image';
import SearchableLazyLoadingSelect from '../../Components/SearchableLazyLoadingSelect';
import { ErrorWrapper } from '../../Components/ReusableComponents';
import ErrorMessage from '../../Components/ErrorMessage';
// import SearchableSelect from '../../Components/SearchableSelect';
import { __, getHighlightedText } from '../../Utils';
import API2 from '../../API2';

const Image = styled(Img)`
  height: ${rem(24)};
  max-width: ${rem(24)};
  margin-right: ${rem(8)};
`;

const BigImage = styled(Img)`
  height: ${rem(100)};
  margin-right: ${rem(16)};
  @media (min-width: 1630px) {
    margin-left: ${rem(16)};
  }
`;

const BigImageWrapper = styled.div`
  height: ${rem(100)};
  width: ${rem(150)};
  min-width: ${rem(100)};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${rem(16)};
  @media (min-width: 1500px) {
    margin-left: ${rem(16)};
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 1500px) {
    flex-direction: row;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  font-size: ${rem(14)};
`;

const ProductDescWrapper = styled.div`
  display: flex;
`;

const ShortDescription = styled.div`
  margin-bottom: ${rem(12)};
  font-weight: 800;
`;
const LongDescription = styled.div`
  margin-bottom: ${rem(16)};
  text-align: justify;
  max-height: ${rem(230)};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ItemWrapper = styled.div`
  margin-right: ${rem(16)};
`;

const SearchableSelectWrapper = styled.div`
  width: ${rem(400)};
  margin-bottom: ${rem(16)};
`;

const SearchImageWrapper = styled.div`
  display: flex;
`;

const LoadingWrapper = styled.div`
  display: flex;
  margin-top: 8px;
  font-size: 12px;
  align-items: center;
`;

const Space = styled.div`
  width: ${rem(24)};
  height: ${rem(24)};
`;

const baseURL = process.env.REACT_APP_IMAGES_PREFIX;

class FirstStep extends React.Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = {
      error: false,
      product: null,
      shortDescription: '',
      longDescription: '',
      bases: [],
      volumes: [],
      imageFullPath: null,
      defaultSearchText: null,
    };
  }
  async componentDidMount() {
    if (this.props.productId) {
      this.setState({
        loading: true,
      });

      try {
        const result = await API2.getB2BCatalogProductAction(
          this.props.productId,
        );

        this.setState({
          defaultSearchText: result.name,
        });

        this.handleProductChange(
          {
            label: '',
            fullName: result.name,
            value: result._id,
            image:
              result.images.find(i => i.name === 'main') &&
              result.images.find(i => i.name === 'main').path,
            raw: result,
          },
          false,
        );
      } catch (e) {
        console.log(e);
      }
    } else {
      this.textInput.current.focus();
    }
  }
  componentWillUnmount() {
    this.setState({
      error: false,
      product: null,
      shortDescription: '',
      longDescription: '',
      bases: [],
      volumes: [],
    });
  }

  async handleProductChange(product, refreshNextSteps = true) {
    this.setState({
      product: product.raw,
      loading: true,
    });

    if (product) {
      try {
        const result = await Promise.all([
          API2.getB2BCatalogProductAction(product.value),
          API2.getB2BCatalogProductVariantsAction(product.value),
        ]);

        const detail = result[0];
        const variants = result[1];

        console.log({
          detail,
          variants,
        });

        this.setState(
          {
            shortDescription: detail.shortDescription,
            longDescription: detail.description,
            imageFullPath: product.image,
            bases: detail.baseTypes,
            volumes:
              variants && variants.variants
                ? variants.variants.map(v => v.volume)
                : [],
            loading: false,
          },
          () => {
            this.props.callback(detail, detail.baseTypes, refreshNextSteps);
          },
        );
      } catch (e) {
        this.setState({
          error: __('Produkt sa nepodarilo načítať'),
        });
      }
    } else {
      this.props.callback(undefined, [], refreshNextSteps);
    }
  }

  fetchProducts(searchText, limit, offset) {
    return API2.getUltraLiteB2BCatalogProductsAction({
      q: searchText,
      // getFullLimit: true,
      // filters: JSON.stringify({
      //   filter: [
      //     {
      //       id: 'brand',
      //       values: this.props.brandsFilter
      //         .filter(f => f.value === true)
      //         .map(m => m.label),
      //       logic: 'OR',
      //     },
      //     {
      //       id: 'type',
      //       values: [
      //         'FARBA',
      //         'SPREJ',
      //         'glazura',
      //         'omietka',
      //         'moridlo',
      //         'olej',
      //         'vosk',
      //         'lazúra',
      //         'fasada',
      //       ],
      //       logic: 'OR',
      //     },
      //   ],
      // }),
      limit,
      offset,
      // canBeToned: true,
    }).then(res => {
      return {
        options: res.products.map(item => ({
          label: (
            <React.Fragment>
              <Image
                src={[
                  `${baseURL}/images/32x0/${item.image_src}`,
                  `${baseURL}/images/32x0/${item.alt_image_src}`,
                ]}
                loader={<Loader color="#70af00" />}
              />
              {getHighlightedText(item.name, searchText)}
            </React.Fragment>
          ),
          fullName: item.name,
          value: item._id,
          image: item.image_src,
          raw: item,
        })),
        next_offset: res.next_offset,
      };
    });
  }

  render() {
    const {
      error,
      product,
      loading,
      shortDescription,
      longDescription,
      bases,
      volumes,
      defaultSearchText,
      imageFullPath,
    } = this.state;

    if (error) {
      return (
        <ErrorWrapper>
          <ErrorMessage display={error} text={error} />
        </ErrorWrapper>
      );
    }

    return (
      <Wrapper>
        <SearchImageWrapper>
          <SearchableSelectWrapper>
            <Label>{__('Názov produktu')}</Label>
            <SearchableLazyLoadingSelect
              key={JSON.stringify(this.props.brandsFilter)}
              inputRef={this.textInput}
              placeholder={__('Názov')}
              openOnLoad
              fetchData={(q, l, o) => {
                return this.fetchProducts(q, l, o);
              }}
              hideItems={loading}
              defaultSearchText={defaultSearchText}
              renderItem={i => this.renderProductItem(i)}
              onSelect={e => this.handleProductChange(e)}
            />
            {loading && (
              <LoadingWrapper>
                <Loader />
                <Space /> {__('Načítavam produkt')}
              </LoadingWrapper>
            )}
          </SearchableSelectWrapper>
          {imageFullPath && (
            <BigImageWrapper>
              <BigImage
                src={[`${baseURL}/images/1000x0/${imageFullPath}`]}
                loader={<Loader color="#1D71B8" />}
              />
            </BigImageWrapper>
          )}
        </SearchImageWrapper>
        {product && !loading && (
          <ContentWrapper>
            <ProductDescWrapper>
              <ItemWrapper style={{ maxWidth: rem(500) }}>
                <ShortDescription>{shortDescription}</ShortDescription>
                <LongDescription>{longDescription}</LongDescription>
              </ItemWrapper>
              <ItemWrapper
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <ItemWrapper>
                  <Label>{__('Bázy')}</Label>
                  <LongDescription>
                    {bases.filter(b => b !== '-').join(', ')}
                  </LongDescription>
                </ItemWrapper>
                <ItemWrapper>
                  <Label>{__('Plnenia')}</Label>
                  <LongDescription>
                    {`${volumes
                      .filter((v, index) => volumes.indexOf(v) === index)
                      .join('L, ')} L`}
                  </LongDescription>
                </ItemWrapper>
              </ItemWrapper>
            </ProductDescWrapper>
          </ContentWrapper>
        )}
      </Wrapper>
    );
  }
}
FirstStep.propTypes = {
  history: PropTypes.shape({}).isRequired,
  callback: PropTypes.func.isRequired,
  productId: PropTypes.string,
  brandsFilter: PropTypes.arrayOf({}),
};

FirstStep.defaultProps = {
  productId: undefined,
  brandsFilter: [],
};

export default FirstStep;



// WEBPACK FOOTER //
// ./src/Containers/Toning/firstStep.jsx